import { Phone } from '@foxeet/utils/classes/contact.class';
import { ContactConfig } from '@foxeet/utils/interfaces';

const PHONE = '6********';
const COUNTRY_CODE = '34';
export const CONTACT_PHONE = '+34 6********';
export const CONTACT_PHONE_DISPLAY = '+34 6********';
export const CONTACT_NAME = 'Inteligencia Versátil';
export const CONTACT_EMAIL = 'info@test.com';

export const contactConfig: ContactConfig = {
  name: CONTACT_NAME,
  email: CONTACT_EMAIL,
  phone: new Phone(COUNTRY_CODE, PHONE),
  phoneDisplay: CONTACT_PHONE,
};
